// extracted by mini-css-extract-plugin
export var auto = "_4a-1";
export var spinner = "_4a-0";